module.exports = "https://www.ilove11.top/img/face33.daa0a7f1.gif";